import { render } from "./FieldsEdit.vue?vue&type=template&id=68a13002&scoped=true"
import script from "./FieldsEdit.vue?vue&type=script&lang=js"
export * from "./FieldsEdit.vue?vue&type=script&lang=js"

import "./FieldsEdit.vue?vue&type=style&index=0&id=68a13002&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a13002"]])

export default __exports__